import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../../hooks/useAuth';
import { useFirebase } from '../../../hooks/useFirebase';
import { queryGet } from '../../tools/tools';

export const useOrderDetail = (orderNumber) => {
  const { user } = useAuth();
  const { remoteConfig } = useFirebase();

  const { data, isLoading, isError } = useQuery({
    queryKey: ['sales-order-detail', orderNumber],
    queryFn: () => queryGet(remoteConfig, `/order/number/${encodeURIComponent(orderNumber)}`, user?.accessToken),
    enabled: !!user?.accessToken && !!remoteConfig && !!orderNumber
  });

  return {
    data,
    loading: isLoading,
    error: isError
  };
};
